This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div>
    <nav class="navbar">
      <router-link to="/">
        <img
          class="brand"
          src="@/assets/images/Logo.svg"
          alt="CodeQuest logo"
        />
      </router-link>
      <ul v-if="this.hasAuthTokens">
        <li
          v-if="getUserInfo().permissionLevel !== 'student'"
          class="dropdown"
          @mouseleave="teacherDropdown = ''"
          @mouseenter="teacherDropdown = 'dropped'"
          :class="teacherDropdown"
        >
          <router-link to="/docent" class="blockOpen">
            <div class="menu-active-left"></div>
            <img
              src="@/assets/images/navbar/Teacher.svg"
              alt="Teacher navbar icon"
            />
            {{ $t("general.navbar.teacher") }}
            <div class="menu-active-right"></div>
          </router-link>
          <div class="teacher-dropdown">
            <ul>
              <li>
                <router-link to="/docent/klassen">
                  {{ $t("general.navbar.classes") }}
                </router-link>
              </li>
              <li>
                <router-link to="/docent/classroompackages">
                  {{ $t("general.navbar.assignBundles") }}
                </router-link>
              </li>
              <li>
                <router-link to="/docent/lespakketten">
                  {{ $t("general.navbar.lessonPackages") }}
                </router-link>
              </li>
              <li>
                <router-link to="/docent/levels">
                  {{ $t("general.navbar.levelMaker") }}
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <li>
          <router-link to="/levels">
            <div class="menu-active-left"></div>
            <img
              src="@/assets/images/navbar/Levels.svg"
              alt="Levels navbar icon"
            />
            {{ $t("general.navbar.levels") }}
            <div class="menu-active-right"></div>
          </router-link>
        </li>
        <li>
          <router-link to="/prestaties">
            <div class="menu-active-left"></div>
            <img
              src="@/assets/images/navbar/Achievements.svg"
              alt="Achievements navbar icon"
            />
            {{ $t("general.navbar.achievements") }}
            <div class="menu-active-right"></div>
          </router-link>
        </li>
        <li>
          <router-link to="/wiki">
            <div class="menu-active-left"></div>
            <img src="@/assets/images/navbar/Wiki.svg" alt="Wiki navbar icon" />
            {{ $t("general.navbar.wiki") }}
            <div class="menu-active-right"></div>
          </router-link>
        </li>
        <li
          class="dropdown"
          @mouseleave="profileDropdown = ''"
          @mouseenter="profileDropdown = 'dropped'"
          :class="profileDropdown"
        >
          <router-link to="/user" class="blockOpen">
            <div class="menu-active-left"></div>
            <img
              class="profile-icon"
              :src="currentAvatar().src"
              alt="Navbar profile icon"
            />
            <div class="menu-active-right profile"></div>
          </router-link>
          <div class="profile-dropdown">
            <ul>
              <li>
                <router-link to="/user/profiel">
                  {{ $t("general.navbar.profile") }}
                </router-link>
              </li>
              <li>
                <router-link to="/user/instellingen">
                  {{ $t("general.navbar.settings") }}
                </router-link>
              </li>
              <li>
                <router-link to="/" @click="logOut()">
                  {{ $t("general.navbar.logOut") }}
                </router-link>
              </li>
            </ul>
          </div>
        </li>
      </ul>
      <ul v-else>
        <!--If not logged in: show login button and wiki and nothing else-->
        <li>
          <router-link to="/wiki">
            <div class="menu-active-left"></div>
            <img src="@/assets/images/navbar/Wiki.svg" alt="Wiki navbar icon" />
            {{ $t("general.navbar.wiki") }}
            <div class="menu-active-right"></div>
          </router-link>
        </li>
        <li>
          <router-link to="/redirect">
            <div class="menu-active-left"></div>
            <img
              class="login-icon"
              src="@/assets/images/navbar/Login.svg"
              alt="Login navbar icon"
            />
            <div class="menu-active-right profile"></div>
          </router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { currentAvatar } from "@/utils/Avatars";
import { getUserInfo } from "@/utils/Functions";

@Options({
  data() {
    return {
      teacherDropdown: "",
      profileDropdown: "",
    };
  },
  computed: {
    /**
     * Check if user has authentication tokens
     * @returns Bool yes or no tokens
     */
    hasAuthTokens() {
      return this.$store.getters.getAuthTokens !== undefined;
    },
  },
  methods: {
    //Log user out
    logOut() {
      this.$store.commit("setAuthTokens", undefined);
      this.$store.commit("setUserInfo", undefined);
    },
    currentAvatar,
    getUserInfo,
  },
})
export default class Navbar extends Vue {}
</script>
